import { handle401 } from './handle401';
import { getGatewayToken } from './getGatewayToken';

export async function fetchWithAuth(url, options = {}) {
  const token = getGatewayToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    ...options.headers,
  };
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) {
    handle401();
  }
  return response;
}



// WEBPACK FOOTER //
// ./src/libs/fetchWithAuth.js